import React, { useEffect, useState, useCallback } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
import useWindowRezise from './hooks/useWindowRezise';
import { throttle } from 'lodash-es';

const Navigation = () => {
    const [logoSrc, setLogoSrc] = useState(null);

    const { width } = useWindowRezise();

    const [navOffSetTop, setoffSetTop] = useState(null);
    const [prevScrollpos, setPrevScrollpos] = useState(window.scrollY);
    const navbar = document.querySelector('.header__row-wrapper');

    const clickHandler = useCallback((event) => {
        const openedMenu = event.target.querySelector('.navbar__menu--show');
        if (openedMenu) {
            openedMenu.classList.remove('navbar__menu--show');
            document.querySelector('#header').classList.remove('overlay');
        }
    }, []);
    useEffect(() => {
        // listen for click event to hide the search when clicking outside
        window.addEventListener('mousedown', clickHandler);
        return () => window.removeEventListener('mousedown', clickHandler);
    }, [clickHandler]);

    const handleScroll = () => {
        if (width > 767) {
            if (window.scrollY >= navOffSetTop + 10) {
                navbar.classList.add('sticky-nav');
                navbar.parentNode.classList.add('sticky-nav');
            } else {
                navbar.classList.remove('sticky-nav');
                navbar.parentNode.classList.remove('sticky-nav');
            }
        } else {
            const currentScrollPos = window.scrollY;
            if (prevScrollpos > currentScrollPos) {
                navbar.parentNode.classList.remove('hide-nav-on-scroll');
            } else {
                navbar.parentNode.classList.add('hide-nav-on-scroll');
            }
            setPrevScrollpos(currentScrollPos);
        }
    };

    useEffect(() => {
        const throttledScroll = throttle(handleScroll, 200);
        if (width > 767) {
            if (navbar && navOffSetTop == null) {
                setoffSetTop(navbar.offsetTop);
            }
        } else {
            if (navbar.classList.contains('sticky-nav')) {
                navbar.classList.remove('sticky-nav');
                navbar.parentNode.classList.remove('sticky-nav');
            }
        }
        window.addEventListener('scroll', throttledScroll);
        return () => {
            window.removeEventListener('scroll', throttledScroll);
        };
    }, [handleScroll]);

    useEffect(() => {
        const logoImg = document.querySelector('.header__logo img');
        if (typeof logoSrc !== 'undefined') setLogoSrc(logoImg.src);
    }, []);
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const additionalLinks = useSelector(
        (state) => state.navigation.additionalHeaderLinks
    );

    return (
        <NavigationItem
            logoSrc={logoSrc}
            links={contentLinks}
            additionalHeaderLinks={additionalLinks}
            width={width}
        />
    );
};

export default Navigation;
